import { graphql } from '@search/gql-client/src';

export const GetPricesAllQuery = graphql`
    query GetPricesAllQuery($offersParams: [OrderOfferVasOfferParam!]!, $promocode: String) {
        getPricesAll(offersParams: $offersParams, promocode: $promocode) {
            bffError
            top {
                daysAmount
                dateTill {
                    day
                    month
                    year
                }
                daysQuantityDiscountPercent
                offersAmount
                offersQuantityDiscountPercent
                offersUniqueDiscountPercent
                totalBasePrice
                totalPrice
                offersQuantityDiscount
                offersPacketDiscount
                offersPacketDiscountPercent
                offersDaysDiscountPrice
                promocodeInfo {
                    success
                    status
                    discountPercent
                    productPrefix
                }
            }
            highlight {
                daysAmount
                dateTill {
                    day
                    month
                    year
                }
                daysQuantityDiscountPercent
                offersAmount
                offersQuantityDiscountPercent
                offersUniqueDiscountPercent
                totalBasePrice
                totalPrice
                offersQuantityDiscount
                offersPacketDiscount
                offersPacketDiscountPercent
                offersDaysDiscountPrice
                promocodeInfo {
                    success
                    status
                    discountPercent
                    productPrefix
                }
            }
            topHighlight {
                daysAmount
                dateTill {
                    day
                    month
                    year
                }
                daysQuantityDiscountPercent
                offersAmount
                offersQuantityDiscountPercent
                offersUniqueDiscountPercent
                totalBasePrice
                totalPrice
                offersQuantityDiscount
                offersPacketDiscount
                offersPacketDiscountPercent
                offersDaysDiscountPrice
                promocodeInfo {
                    success
                    status
                    discountPercent
                    productPrefix
                }
            }
        }
    }
`;
